import React, { useState, useEffect } from 'react';
import PrimeReactSingleSelectChip from '../../atoms/single-select-dropdown-chip/single-select-dropdown-chip';
import { useApiClientsOrNull } from '../../../context/ApiClientsContext';

import { useTranslation } from 'localization';
import './perspective.scss';

interface Option {
  name: string;
  code: string;
}
interface PerspectiveProps {
  sphereId: string;
}
interface Perspective {
  name: string;
  code: string;
  properties: {
    name: string;
  };
}
const Perspective: React.FC<PerspectiveProps> = ({ sphereId }) => {
  const apiClients = useApiClientsOrNull();
  const [selectedOption, setSelectedOption] = useState<Option | null>(null);
  const [options, setOptions] = useState<Option[]>([]);
  const { t } = useTranslation();

  useEffect(() => {
    if (!apiClients || !sphereId) return;
    const { graphClient } = apiClients;

    const fetchData = async () => {
      try {
        const data = await graphClient.get<Perspective[]>(
          `/spheres/${encodeURIComponent(sphereId)}/perspectives`
        );

        // Extract the perspectives and map them to options
        const perspectivesOptions = data.map((perspective: Perspective) => ({
          name: perspective.properties.name,
          code: perspective.properties.name,
        }));

        setOptions(perspectivesOptions);
      } catch (error) {
        console.error('Failed to fetch data:', error);
      }
    };

    fetchData();
  }, [sphereId, apiClients]);

  const handleSelectionChange = (e: { value: Option }) => {
    setSelectedOption(e.value);
  };

  return (
    <PrimeReactSingleSelectChip
      value={selectedOption}
      options={(options)}
      onChange={handleSelectionChange}
      placeholder={t('Perspective.default')}
      optionLabel="name"
      filter={true}
      showRadioButton={true}
      showChip={true}
      className={`perspective-single-select ${selectedOption ? 'selected' : ''}`}
    />
  );
};

export default Perspective;
